import { NavLink } from "@/components/NavLink";
import mikoCharacter from "@/assets/miko-character.png";
import { 
  Info, 
  Mail, 
  ShoppingBag, 
  ExternalLink,
  Building2,
  Users,
  Book,
  FileText,
  Sparkles
} from "lucide-react";



interface MehrMegaMenuProps {
  onClose: () => void;
}

export const MehrMegaMenu = ({ onClose }: MehrMegaMenuProps) => {
  return (
    <div className="w-[700px] p-6">
      <div className="mb-5">
        <h2 className="text-2xl font-bold text-foreground mb-1">Mehr</h2>
        <p className="text-sm text-muted-foreground">
          Weitere Angebote und Informationen
        </p>
      </div>
      
      <div className="grid grid-cols-3 gap-6">
        {/* Für wen? */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="p-2 rounded-lg bg-accent/10 text-accent">
              <Users className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-foreground">Für wen?</h3>
          </div>
          <NavLink to="/paedagogische-fachkraefte" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Users className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Pädagogische Fachkräfte</span>
          </NavLink>
          <NavLink to="/musik-kita" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Building2 className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Kitas & Einrichtungen</span>
          </NavLink>
          <div className="ml-6 space-y-1">
            <NavLink to="/musik-kita-verzeichnis" onClick={onClose} className="flex items-center gap-2 p-1.5 rounded-lg hover:bg-muted/50 transition-colors group">
              <Book className="w-3 h-3 text-muted-foreground group-hover:text-accent" />
              <span className="text-xs font-normal text-muted-foreground group-hover:text-foreground">Musik-Kita-Verzeichnis</span>
            </NavLink>
          </div>

        </div>

        {/* Angebote vor Ort */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="p-2 rounded-lg bg-primary/10 text-primary">
              <Building2 className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-foreground">Vor Ort</h3>
          </div>
          <NavLink to="/inhouse-schulungen" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Users className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Fortbildung vor Ort</span>
          </NavLink>
          <NavLink to="/musikonzept-vor-ort" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Building2 className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">MusiKonzept vor Ort</span>
          </NavLink>
        </div>

        {/* Über uns & Kontakt + Shop + Miko */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="p-2 rounded-lg bg-primary/10 text-primary">
              <Info className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-foreground">Über uns</h3>
          </div>

          <NavLink to="/miko" onClick={onClose} className="flex items-center gap-2 p-2 rounded-xl bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20 hover:border-primary/30 transition-all group mb-2">
            <img src={mikoCharacter} alt="Miko" className="w-8 h-8 rounded-full bg-white/80 dark:bg-card" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground group-hover:text-primary">Miko – KI-Assistent</span>
                <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary/20 text-primary font-semibold">KI</span>
              </div>
              <span className="text-xs text-muted-foreground">Dein intelligenter Musik-Begleiter</span>
            </div>
            <Sparkles className="w-4 h-4 text-primary/60 group-hover:text-primary" />
          </NavLink>

          <NavLink to="/ueber-uns" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Info className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Über MusiKonzept</span>
          </NavLink>
          <NavLink to="/community" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Users className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Community</span>
          </NavLink>
          <NavLink to="/kontakt" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <Mail className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Kontakt</span>
          </NavLink>
          <NavLink to="/blog" onClick={onClose} className="flex items-center gap-2 p-2 rounded-lg hover:bg-muted/50 transition-colors group">
            <FileText className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
            <span className="text-sm font-normal text-muted-foreground group-hover:text-foreground">Blog</span>
          </NavLink>

          <div className="pt-3 mt-3 border-t border-border/50">
            <a
              href="https://shop.musikonzept.de"
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors group"
            >
              <ShoppingBag className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary">Shop</span>
              <ExternalLink className="w-3 h-3 text-primary/60" />
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};
